import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component

export default class LoadingComponent extends Vue {
    @Prop()
    name: string;

    isFoldingCube: boolean = false;
    isThreeBounce: boolean = false;
    isThreeBounceNoMargin: boolean = false;

    created(): void {
        if (this.name == "folding-cube")
            this.isFoldingCube = true;
        else if (this.name == "three-bounce")
            this.isThreeBounce = true;
        else if (this.name == "three-bounce-no-margin") {
            this.isThreeBounceNoMargin = true;
        }
        else
            this.isThreeBounce = true;
    }
}